
import Header from './Components/Common/Header/Header';
import Footer from './Components/Common/footer/Footer';
import Home from './Components/Pages/homePages/Home';
// import About from './Components/Pages/About';
// import Solution from './Components/Pages/Solution';
import Pricing from './Components/Pages/pricingPages/Pricing';
// import Contact from './Components/Pages/Contact';
// import Values from './Components/Pages/Values';

// import Herosection from './Components/Pages/Herosection';
// import Oxygenbenefits from './Components/Pages/Oxygenbenefits';
// import Sections from './Components/Pages/Sections';
// import Testimonials from './Components/Pages/Testimonials';
// import Counter from './Components/Pages/Counter'
import { Routes, Route } from 'react-router-dom'
import Resources from './Components/Pages/resources/Resources';
import Contact from './Components/Pages/contact/Contact';
// import Client from './Components/Pages/homePages/Client';
// import Counter from './Components/Pages/Counter';
// import Experts from './Components/Pages/Experts';


function App() {
  return (
    <>
    <Header/>
    <Routes>
    <Route path="/" element={<Home  />} />
    {/* <Route path ="/about" element={<About/>}/> */}
    {/* <Route path ="/solution" element={<Solution/>}/> */}
    <Route path ="/pricing" element={<Pricing/>}/>
    <Route path ="/team" element={<Resources/>}/>
    <Route path ="/contact" element={<Contact/>}/>
    {/* <Route path ="/contact" element={<Contact/>}/> */}
    {/* <Route path ="/experts" element={<Experts/>}/> */}
    {/* <Route path ="/clients" element={<Client/>}/> */}
    {/* <Route path ="/values" element={<Values/>}/> */}
    </Routes>
  
    <Footer/>

    {/* <Routes>
    <Route path="/" element={<Header />} />
    <Route path="/" element={<Herosection/>} />
    </Routes> */}
    </>
  );
}

export default App;

